import { render, staticRenderFns } from "./VerRegistro.vue?vue&type=template&id=4969d09e&scoped=true"
import script from "./VerRegistro.vue?vue&type=script&lang=js"
export * from "./VerRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969d09e",
  null
  
)

export default component.exports